import { render, staticRenderFns } from "./ScoreLeaderboardContent.vue?vue&type=template&id=104a1ed7&scoped=true&"
import script from "./ScoreLeaderboardContent.vue?vue&type=script&lang=js&"
export * from "./ScoreLeaderboardContent.vue?vue&type=script&lang=js&"
import style0 from "./ScoreLeaderboardContent.vue?vue&type=style&index=0&id=104a1ed7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104a1ed7",
  null
  
)

export default component.exports